
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("g7NcR", function(module, exports) {
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $bbd3782e8b8fe295$export$2e2bcd8739ae039 = fn;
 //# sourceMappingURL=immer.esm.js.map
module.exports["isDraft"] = r;
module.exports["isDraftable"] = t;
module.exports["immerable"] = L;
module.exports["original"] = e;
module.exports["freeze"] = d;
module.exports["nothing"] = H;
module.exports["current"] = R;
module.exports["enableES5"] = F;
module.exports["enablePatches"] = T;
module.exports["enableMapSet"] = C;
module.exports["enableAllPlugins"] = J;
module.exports["castDraft"] = K;
module.exports["castImmutable"] = $;
module.exports["Immer"] = un;
module.exports["produce"] = fn;
module.exports["produceWithPatches"] = cn;
module.exports["setAutoFreeze"] = sn;
module.exports["setUseProxies"] = vn;
module.exports["applyPatches"] = pn;
module.exports["createDraft"] = ln;
module.exports["finishDraft"] = dn;
module.exports["default"] = $bbd3782e8b8fe295$export$2e2bcd8739ae039;

});

parcelRegister("k0x5M", function(module, exports) {

var $g7NcR = parcelRequire("g7NcR");

var $a10c9c9702678a05$exports = {};

var $1FFRr = parcelRequire("1FFRr");


var $kxLmQ = parcelRequire("kxLmQ");


var $5RsFr = parcelRequire("5RsFr");

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $a10c9c9702678a05$var$without = $kxLmQ(function(array, values) {
    return $5RsFr(array) ? $1FFRr(array, values) : [];
});
$a10c9c9702678a05$exports = $a10c9c9702678a05$var$without;



var $8rneB = parcelRequire("8rneB");


var $brn6e = parcelRequire("brn6e");


var $dd6Gw = parcelRequire("dd6Gw");


var $2qvBe = parcelRequire("2qvBe");


var $9rjMR = parcelRequire("9rjMR");

const $30e0f79174576267$export$32cfb96166427060 = (page)=>page?.type === 'folder' && page?.subType === 'managed';
const $30e0f79174576267$var$DRAFT_BLOCKED_INSTRUCTIONS = [
    'make-child'
];
const $30e0f79174576267$var$MANAGED_FOLDER_BLOCKED_INSTRUCTIONS = [
    'make-child'
];
const $30e0f79174576267$var$MANAGED_FOLDER_CHILD_BLOCKED_INSTRUCTIONS = [
    'reorder-above',
    'reorder-below',
    'make-child',
    'reparent'
];
const $30e0f79174576267$var$getBlockedInstructions = (page)=>{
    // Managed folders themselves can be moved, but nothing can be dropped INTO them.
    // reorder-above and reorder-below are still allowed to place items next to the folder.
    if ($30e0f79174576267$export$32cfb96166427060(page)) return $30e0f79174576267$var$MANAGED_FOLDER_BLOCKED_INSTRUCTIONS;
    // Drafts cannot have items dropped into them
    if (page.status !== 'CURRENT') return $30e0f79174576267$var$DRAFT_BLOCKED_INSTRUCTIONS;
    return undefined;
};
const $30e0f79174576267$export$832e091562f3ad2f = (items)=>{
    let result;
    for (const id of Object.keys(items)){
        const item = items[id];
        if (!item.parentId) continue;
        const parent = items[item.parentId];
        if (parent && $30e0f79174576267$export$32cfb96166427060(parent.data) && item.blockedInstructions !== $30e0f79174576267$var$MANAGED_FOLDER_CHILD_BLOCKED_INSTRUCTIONS) {
            result = result ?? {
                ...items
            };
            result[id] = {
                ...item,
                blockedInstructions: $30e0f79174576267$var$MANAGED_FOLDER_CHILD_BLOCKED_INSTRUCTIONS
            };
        }
    }
    return result ?? items;
};
const $30e0f79174576267$export$cb621630a8c199ba = (page, isWhiteboardEmojiFGEnabled = false)=>{
    const { text: title, emoji: displayEmoji, selectedEmoji: emojiFromProperties } = (0, $brn6e.getTitleAndEmoji)(page.title, (0, $8rneB.getEmojiFromPublishedPageProperties)(page), (0, $8rneB.getEmojiFromDraftPageProperties)(page), page.status, undefined, isWhiteboardEmojiFGEnabled || page.type !== 'whiteboard');
    const editorVersion = (0, $dd6Gw.getEditorVersionFromPageProperties)(page);
    // editor should be v1, v2, or ""
    return {
        id: page.id,
        children: (0, $2qvBe.getPages)(page.children),
        parentId: page.parentId || null,
        hasChildren: page.hasChildren,
        isExpanded: false,
        isChildrenLoading: false,
        hasRestrictions: page.hasRestrictions || false,
        hasInheritedRestrictions: page.hasInheritedRestrictions || false,
        blockedInstructions: $30e0f79174576267$var$getBlockedInstructions(page),
        data: {
            title: title || '',
            fullTitle: page.title,
            status: page.status,
            blank: page.blank,
            emoji: displayEmoji,
            emojiFromProperties: emojiFromProperties,
            webui: page.links?.webui,
            type: page.type,
            editorVersion: editorVersion,
            subType: page.subType,
            createdDate: page.createdDate?.value,
            isSelected: page.isSelected,
            isOptimistic: page.isOptimistic
        }
    };
};
const $30e0f79174576267$export$b960af109265079f = (currentPage, dictionary = {}, isWhiteboardEmojiFGEnabled = false)=>{
    if (!currentPage) return;
    if (dictionary[currentPage.id]) //there should be no duplicates in server data
    throw new Error('pageTree Data malformed: contains duplicate pages');
    const children = (0, $2qvBe.getPages)(currentPage.children);
    const ancestors = (0, $2qvBe.getPages)(currentPage.nearestAncestors);
    const siblings = [
        ...(0, $2qvBe.getPages)(currentPage.previousSiblings),
        ...(0, $2qvBe.getPages)(currentPage.followingSiblings)
    ];
    dictionary[currentPage.id] = $30e0f79174576267$export$cb621630a8c199ba(currentPage, isWhiteboardEmojiFGEnabled);
    siblings.forEach((sibling)=>$30e0f79174576267$export$b960af109265079f(sibling, dictionary, isWhiteboardEmojiFGEnabled));
    ancestors.forEach((ancestor)=>$30e0f79174576267$export$b960af109265079f(ancestor, dictionary, isWhiteboardEmojiFGEnabled));
    children.forEach((child)=>$30e0f79174576267$export$b960af109265079f(child, dictionary, isWhiteboardEmojiFGEnabled));
    return dictionary;
};
const $30e0f79174576267$export$b57e3e464385c213 = (rootLevel, dictionary = {}, immutable = true)=>{
    const rootLevelPages = (0, $2qvBe.getPages)(rootLevel).map((page)=>{
        const rootLevelPage = $30e0f79174576267$export$cb621630a8c199ba(page);
        dictionary[page.id] = rootLevelPage;
        return rootLevelPage;
    });
    dictionary[0, $9rjMR.VIRTUAL_ROOT_ID] = {
        id: (0, $9rjMR.VIRTUAL_ROOT_ID),
        children: (0, $2qvBe.getIds)(rootLevelPages),
        parentId: null,
        hasChildren: true,
        isExpanded: true,
        isChildrenLoading: false,
        hasRestrictions: false,
        hasInheritedRestrictions: false,
        data: {
            title: '',
            status: '',
            blank: false,
            webui: ''
        }
    };
    dictionary[0, $9rjMR.VIRTUAL_LOCAL_ROOT_ID] = {
        id: (0, $9rjMR.VIRTUAL_LOCAL_ROOT_ID),
        children: [],
        parentId: (0, $9rjMR.VIRTUAL_ROOT_ID),
        hasChildren: true,
        isExpanded: true,
        isChildrenLoading: false,
        hasRestrictions: false,
        hasInheritedRestrictions: false,
        data: {
            title: '',
            status: '',
            blank: false,
            webui: ''
        }
    };
    if (immutable) dictionary = $30e0f79174576267$export$1cf768f83edbc2e0(dictionary);
    return dictionary;
};
const $30e0f79174576267$export$215c1b4f1ba88b23 = (currentPage, rootLevelPages, isWhiteboardEmojiFGEnabled = false)=>{
    let pages = {};
    if (!currentPage) return pages;
    pages = $30e0f79174576267$export$b960af109265079f(currentPage, pages, isWhiteboardEmojiFGEnabled) || {};
    pages = $30e0f79174576267$export$b57e3e464385c213(rootLevelPages, pages, false);
    const ancestors = (0, $2qvBe.getPages)(currentPage.nearestAncestors);
    const children = (0, $2qvBe.getPages)(currentPage.children);
    const currentLevel = [
        ...[
            ...(0, $2qvBe.getPages)(currentPage.previousSiblings)
        ].reverse(),
        {
            id: currentPage.id,
            children: children
        },
        ...(0, $2qvBe.getPages)(currentPage.followingSiblings)
    ];
    // Build references upwards to current page's ancestors
    ancestors.forEach((ancestor, i)=>{
        const ancestorIsParent = i === 0;
        let childrenOfAncestor = [];
        if (ancestorIsParent) childrenOfAncestor = currentLevel;
        else {
            const childOfAncestor = ancestors[i - 1];
            childrenOfAncestor = [
                ...[
                    ...(0, $2qvBe.getPages)(childOfAncestor.previousSiblings)
                ].reverse(),
                childOfAncestor,
                ...(0, $2qvBe.getPages)(childOfAncestor.followingSiblings)
            ];
        }
        const page = pages[ancestor.id];
        if (page) page.children = (0, $2qvBe.getIds)(childrenOfAncestor);
    });
    // Build references downwards to current page's children
    pages[currentPage.id].children = (0, $2qvBe.getIds)(children);
    let deepestLevel = currentLevel;
    if (ancestors.length) {
        const deepestAncestor = ancestors[ancestors.length - 1];
        deepestLevel = [
            ...[
                ...(0, $2qvBe.getPages)(deepestAncestor.previousSiblings)
            ].reverse(),
            deepestAncestor,
            ...(0, $2qvBe.getPages)(deepestAncestor.followingSiblings)
        ];
    }
    pages[0, $9rjMR.VIRTUAL_LOCAL_ROOT_ID].children = (0, $2qvBe.getIds)(deepestLevel);
    pages = $30e0f79174576267$export$1cf768f83edbc2e0(pages);
    return pages;
};
const $30e0f79174576267$export$1b13d58aa3b1c997 = (pages, currentPageId, expandedPages, loadingPages, highlightPages, cursors)=>(0, $g7NcR.default)(pages, (transformedPages)=>{
        for(const id in transformedPages)if (transformedPages.hasOwnProperty(id)) {
            const transformedPage = transformedPages[id];
            transformedPage.isExpanded = expandedPages.has(id);
            transformedPage.isChildrenLoading = loadingPages.has(id);
            transformedPage.data.isSelected = transformedPage.id === currentPageId;
            transformedPage.data.isHighlighted = highlightPages?.includes(transformedPage.id) || false;
            if (cursors?.previous?.id === transformedPage.id || cursors?.following?.id === transformedPage.id) transformedPage.data.isCursor = true;
        }
    });
const $30e0f79174576267$export$1cf768f83edbc2e0 = (pages)=>(0, $g7NcR.default)(pages, (newPages)=>{
        const pageIds = Object.keys(newPages);
        // assign parent id's based on parents children
        pageIds.forEach((id)=>{
            const page = newPages[id];
            if (page && page.children && page.children.length) page.children.forEach((child)=>{
                if (typeof child === 'string' && // In some cases one page can have both VIRTUAL_LOCAL_ROOT_ID and VIRTUAL_ROOT_ID as parent.
                // In this situation VIRTUAL_LOCAL_ROOT_ID has higher priority.
                !(page.id === (0, $9rjMR.VIRTUAL_LOCAL_ROOT_ID) && newPages[child].parentId === (0, $9rjMR.VIRTUAL_ROOT_ID))) newPages[child].parentId = page.id;
            });
        });
    });
const $30e0f79174576267$export$d4cb3dfdb7a8fc7d = (pages, expandedParentId, childrenIds)=>{
    const pagesWithChildren = (0, $g7NcR.default)(pages, (pagesWithChildren)=>{
        pagesWithChildren[expandedParentId].children = childrenIds;
    });
    const withMovedChildren = $30e0f79174576267$var$moveChildrenIfNeeded(pagesWithChildren, childrenIds, expandedParentId);
    return $30e0f79174576267$export$1cf768f83edbc2e0(withMovedChildren);
};
const $30e0f79174576267$var$moveChildrenIfNeeded = (pages, childrenIds, latestParentId)=>(0, $g7NcR.default)(pages, (newPages)=>{
        childrenIds.forEach((childId)=>{
            if (newPages[childId] && newPages[childId].parentId && newPages[childId].parentId !== latestParentId) {
                const oldParent = newPages[newPages[childId].parentId];
                oldParent.children = (0, (/*@__PURE__*/$parcel$interopDefault($a10c9c9702678a05$exports)))(oldParent.children, childId);
            }
        });
    });
const $30e0f79174576267$var$handleSyntheticItem = (syntheticItem, allPages, rootId, syntheticItemIsDraft)=>{
    allPages = {
        ...allPages
    };
    if (syntheticItem && syntheticItem.id) {
        if (!allPages[syntheticItem.id] && !allPages[rootId].children.some((id)=>id === syntheticItem.id)) // If an item with same id isn't present in the tree we got from the server - put it at the very top.
        // Otherwise, we'll leave it where it was, and just override its properties
        allPages[rootId] = {
            ...allPages[rootId],
            children: [
                syntheticItem.id,
                ...allPages[rootId].children
            ]
        };
        const existingPageData = allPages[syntheticItem.id]?.data || {};
        allPages[syntheticItem.id] = {
            ...syntheticItem,
            data: syntheticItemIsDraft ? {
                ...existingPageData,
                ...syntheticItem.data
            } : {
                ...syntheticItem.data,
                ...existingPageData
            }
        };
    }
    return allPages;
};
const $30e0f79174576267$var$correctTreeFlattener = (currentPage, rootLevelPages, isWhiteboardEmojiFGEnabled = false)=>{
    return currentPage ? $30e0f79174576267$export$215c1b4f1ba88b23(currentPage, rootLevelPages, isWhiteboardEmojiFGEnabled) : $30e0f79174576267$export$b57e3e464385c213(rootLevelPages);
};
const $30e0f79174576267$var$determineInitiallyExpandedPages = //only gets doesn't set.
(pages, expandedPages, currentPage, rootLevel, pageTreeStateUpdatesContainer)=>{
    /**
   * Determines the initially expanded subtree after pages are fetched.
   * The current page's ancestors are the only pages that will have children,
   * which is how initially expanded subtree is determined below. Simply sets State
   *
   * @param {object} pages
   */ for(const id in pages){
        const page = pages[id];
        if (page.hasChildren && (0, $2qvBe.childrenAreLatest)(page) && page.isExpanded) expandedPages.add(page.id);
    }
    // Don't expand during creation flow for content that has inline
    // renaming instead of a create content route, such as folders
    const editingTitle = pageTreeStateUpdatesContainer?.state?.editingTitle;
    const isCurrentPageInCreationFlow = editingTitle?.isNewContent && currentPage?.id === editingTitle?.contentId;
    if (currentPage && !rootLevel && !isCurrentPageInCreationFlow) {
        expandedPages.add(currentPage.id);
        const ancestors = currentPage.nearestAncestors.nodes;
        ancestors.forEach((page)=>{
            expandedPages.add(page.id);
        });
    }
    return expandedPages;
};
const $30e0f79174576267$export$bce2ae002a2919ea = (data, spaceKey, state, isPeekingFromBlogs, syntheticItem, syntheticItemIsDraft, pageTreeStateUpdatesContainer, isWhiteboardEmojiFGEnabled = false)=>{
    //need to determine if there is no homepage, if not we must populate rootLevelPages / syntheticLocalRoot
    const { space: space } = data;
    const rootLevelPages = {
        nodes: [],
        pageInfo: {}
    };
    let currentPage;
    let rootLevel = null;
    if (data?.ptpage?.followingSiblings && !data?.currentPage) {
        currentPage = {
            ...data.ptpage,
            previousSiblings: {
                nodes: [],
                pageInfo: {}
            },
            children: {
                nodes: [],
                pageInfo: {}
            },
            nearestAncestors: {
                nodes: [],
                pageInfo: {}
            }
        };
        rootLevel = (0, $9rjMR.VIRTUAL_LOCAL_ROOT_ID); // if we are displaying only root level pages, always use virtual root
    } else currentPage = data?.currentPage;
    const serverPages = $30e0f79174576267$var$correctTreeFlattener(currentPage, rootLevelPages, isWhiteboardEmojiFGEnabled);
    // @ts-ignore
    let allPages = (0, $2qvBe.mergePages)(state.pages, serverPages);
    const spaceHomePageId = space?.homepage?.id;
    const rootId = rootLevel || (0, $2qvBe.getRootId)(allPages, currentPage?.id, spaceHomePageId);
    const cursors = (0, $2qvBe.getDirectionalCursors)(currentPage, rootId, {});
    //set the space overview root now that we have it
    //"noHomepageFound" prevents infinite loop if space.homepage.id is undefined & returns
    //the orphaned page root
    const blogPeekRoot = isPeekingFromBlogs ? space.homepage && space.homepage.id || 'noHomepageFound' : undefined;
    allPages = $30e0f79174576267$var$handleSyntheticItem(syntheticItem, allPages, rootId, syntheticItemIsDraft);
    const expandedPages = $30e0f79174576267$var$determineInitiallyExpandedPages(allPages, state.expandedPages, currentPage, rootLevel, pageTreeStateUpdatesContainer);
    const newState = {
        rootId: rootId,
        pages: allPages,
        space: space,
        spaceKey: spaceKey,
        expandedPages: expandedPages,
        isTreeTruncatedPrevious: (0, $2qvBe.isPageTreeTruncatedPrevious)(currentPage),
        isTreeTruncatedFollowing: (0, $2qvBe.isPageTreeTruncatedFollowing)(currentPage),
        cursors: cursors,
        initialPages: currentPage,
        blogPeekRoot: blogPeekRoot
    };
    return newState;
};
module.exports["isManagedFolder"] = $30e0f79174576267$export$32cfb96166427060;
module.exports["applyManagedFolderRestrictions"] = $30e0f79174576267$export$832e091562f3ad2f;
module.exports["createTreeItem"] = $30e0f79174576267$export$cb621630a8c199ba;
module.exports["flattenTreeData"] = $30e0f79174576267$export$215c1b4f1ba88b23;
module.exports["transformUIAttributes"] = $30e0f79174576267$export$1b13d58aa3b1c997;
module.exports["setChildren"] = $30e0f79174576267$export$d4cb3dfdb7a8fc7d;
module.exports["deriveStateFromData"] = $30e0f79174576267$export$bce2ae002a2919ea;

});

parcelRegister("2qvBe", function(module, exports) {

var $g7NcR = parcelRequire("g7NcR");


var $4pQus = parcelRequire("4pQus");


var $9rjMR = parcelRequire("9rjMR");

const $2d6e196d41c25516$export$f4348e32a399a3d5 = (parent)=>{
    return parent?.nodes?.length ? parent.nodes : [];
};
const $2d6e196d41c25516$export$24b60fe7179439bc = (pages)=>pages.map((page)=>page.id);
const $2d6e196d41c25516$export$dfdcab00b0f585a9 = (pages, currentPageId, spaceHomePageId)=>{
    if (!spaceHomePageId || !pages || !currentPageId) return 0, $9rjMR.VIRTUAL_LOCAL_ROOT_ID;
    const currentPage = pages[currentPageId];
    if (!currentPage) return 0, $9rjMR.VIRTUAL_LOCAL_ROOT_ID;
    switch(currentPageId){
        case spaceHomePageId:
            return spaceHomePageId;
        case 0, $9rjMR.VIRTUAL_LOCAL_ROOT_ID:
            return 0, $9rjMR.VIRTUAL_LOCAL_ROOT_ID;
        default:
            return $2d6e196d41c25516$export$dfdcab00b0f585a9(pages, currentPage.parentId, spaceHomePageId);
    }
};
const $2d6e196d41c25516$export$34b8009d9e031a81 = (page)=>(!page.hasChildren || Boolean(page.children) && page.children.length > 0) && !page.hasAdditionalChildren;
const $2d6e196d41c25516$export$a03c6b8408b76abc = (allPages, newPages)=>(0, $g7NcR.default)(allPages, (mergedPages)=>{
        for(const pageId in newPages){
            const oldPage = allPages[pageId];
            const newPage = newPages[pageId];
            if (oldPage) {
                const children = $2d6e196d41c25516$export$34b8009d9e031a81(newPage) ? newPage.children : oldPage.children;
                const parentId = //ensures when paginating we don't accidentally leave behind a page incorrectly pointing to
                // the Virtual root causing the space overview to display in the tree
                oldPage.parentId === (0, $9rjMR.VIRTUAL_LOCAL_ROOT_ID) && newPage?.parentId || oldPage.parentId;
                mergedPages[pageId] = {
                    ...newPage,
                    parentId: parentId,
                    children: children
                };
            } else mergedPages[pageId] = newPage;
        }
        return mergedPages;
    });
const $2d6e196d41c25516$export$f44f2073cd5157ff = (allChildren, newChildren)=>({
        nodes: [
            ...allChildren.nodes,
            ...newChildren.nodes
        ]
    });
const $2d6e196d41c25516$export$b7edc5fdcf19d0d6 = (page)=>{
    if (!page) return false;
    const { followingSiblings: followingSiblings, nearestAncestors: nearestAncestors } = page;
    const pagesDontExistBelowForKnownAncestors = !(followingSiblings?.pageInfo?.hasNextPage || nearestAncestors.nodes.some((ancestor)=>ancestor.followingSiblings?.pageInfo?.hasNextPage));
    const moreAncestorsExist = nearestAncestors?.pageInfo?.hasNextPage;
    return pagesDontExistBelowForKnownAncestors && moreAncestorsExist;
};
const $2d6e196d41c25516$export$617edbc60225ba65 = (page)=>{
    if (!page) return false;
    const { previousSiblings: previousSiblings, nearestAncestors: nearestAncestors } = page;
    return nearestAncestors?.pageInfo?.hasNextPage || previousSiblings?.pageInfo?.hasNextPage || nearestAncestors.nodes.some((ancestor)=>ancestor.previousSiblings?.pageInfo?.hasNextPage);
};
const $2d6e196d41c25516$export$d5bc22e72508f579 = (page)=>{
    if (!page) return false;
    const { followingSiblings: followingSiblings, children: children, nearestAncestors: nearestAncestors } = page;
    if ($2d6e196d41c25516$export$b7edc5fdcf19d0d6(page)) return true;
    return followingSiblings?.pageInfo?.hasNextPage || children?.pageInfo?.hasNextPage || // we only request children on first load
    nearestAncestors.nodes.some((ancestor)=>ancestor.followingSiblings?.pageInfo?.hasNextPage);
};
const $2d6e196d41c25516$export$e96fe946844343ed = (pageId, allPages, idSet)=>{
    if (allPages[pageId]) {
        const { parentId: parentId } = allPages[pageId];
        if (parentId) {
            idSet.add(parentId);
            return $2d6e196d41c25516$export$e96fe946844343ed(parentId, allPages, idSet);
        }
    }
    return idSet;
};
const $2d6e196d41c25516$var$emptyField = ()=>({
        nodes: [],
        pageInfo: {
            hasNextPage: false
        }
    });
const $2d6e196d41c25516$var$emptyFieldWithNextPage = ()=>({
        nodes: [],
        pageInfo: {
            hasNextPage: true
        }
    });
/*
 * if ancestorIndex is -2, and we need to shift UP one level and utilize children
 * if ancestorIndex is -1, no changes are needed
 * if ancestorIndex is 0 or higher, we need to shift DOWN n levels, where n = ancestorIndex + 1.
 */ const $2d6e196d41c25516$var$shiftedSiblings = (currentPage, ancestorIndex, fieldName)=>{
    const allSiblings = [
        currentPage[fieldName],
        ...currentPage.nearestAncestors.nodes.map((a)=>a[fieldName])
    ];
    return {
        children: ancestorIndex < -1 ? allSiblings.shift() : $2d6e196d41c25516$var$emptyField(),
        siblings: ancestorIndex < 0 ? allSiblings.shift() : $2d6e196d41c25516$var$emptyField(),
        ancestorSiblings: [
            ...Array.from({
                length: Math.max(0, ancestorIndex)
            }).map($2d6e196d41c25516$var$emptyField),
            ...allSiblings
        ]
    };
};
const $2d6e196d41c25516$var$removeSiblingsFromAncestors = (currentPage)=>{
    return {
        nodes: currentPage.nearestAncestors.nodes.map((ancestor)=>{
            const { previousSiblings: previousSiblings, followingSiblings: followingSiblings, ...otherFields } = ancestor;
            // Show more above bug - if currentpage has no following siblings when merging
            // and in feature gate, we set hasNextPage optimistically to true
            return {
                previousSiblings: $2d6e196d41c25516$var$emptyField(),
                followingSiblings: !followingSiblings ? $2d6e196d41c25516$var$emptyFieldWithNextPage() : $2d6e196d41c25516$var$emptyField(),
                ...otherFields
            };
        }),
        pageInfo: currentPage.nearestAncestors.pageInfo
    };
};
const $2d6e196d41c25516$export$6fd1afbfe6d62ded = (currentPage, allPages, ancestorIndex)=>{
    if (!allPages) return currentPage;
    return (0, $g7NcR.default)(allPages, (mergedPages)=>{
        var _mpFollowingSiblings_pageInfo, _mpChildren_pageInfo;
        const { followingSiblings: mpFollowingSiblings, nearestAncestors: mpNearestAncestors, children: mpChildren } = mergedPages;
        const { children: children, siblings: siblings, ancestorSiblings: ancestorSiblings } = $2d6e196d41c25516$var$shiftedSiblings(currentPage, ancestorIndex, 'followingSiblings');
        // followingSiblings
        mpFollowingSiblings.nodes = (0, (/*@__PURE__*/$parcel$interopDefault($4pQus)))(mpFollowingSiblings?.nodes, siblings?.nodes, 'id');
        (_mpFollowingSiblings_pageInfo = mpFollowingSiblings.pageInfo).hasNextPage && (_mpFollowingSiblings_pageInfo.hasNextPage = siblings?.pageInfo?.hasNextPage);
        // children
        mpChildren.nodes = (0, (/*@__PURE__*/$parcel$interopDefault($4pQus)))(mpChildren?.nodes, children?.nodes, 'id');
        (_mpChildren_pageInfo = mpChildren.pageInfo).hasNextPage && (_mpChildren_pageInfo.hasNextPage = children?.pageInfo?.hasNextPage);
        // nearestAncestors.followingSiblings
        ancestorSiblings.forEach((ancestorSiblingsAtLevel, i)=>{
            const ancestor = mpNearestAncestors?.nodes?.[i];
            if (ancestor) {
                var _ancestor_followingSiblings_pageInfo;
                ancestor.followingSiblings.nodes = (0, (/*@__PURE__*/$parcel$interopDefault($4pQus)))(ancestor.followingSiblings?.nodes, ancestorSiblingsAtLevel?.nodes, 'id');
                (_ancestor_followingSiblings_pageInfo = ancestor.followingSiblings.pageInfo).hasNextPage && (_ancestor_followingSiblings_pageInfo.hasNextPage = ancestorSiblingsAtLevel.pageInfo?.hasNextPage);
            }
        });
        return mergedPages;
    });
};
const $2d6e196d41c25516$export$880f73148296bc22 = (currentPage, allPages, ancestorIndex)=>{
    if (!allPages) return currentPage;
    return (0, $g7NcR.default)(allPages, (mergedPages)=>{
        var _mpPreviousSiblings_pageInfo, _mpNearestAncestors_pageInfo;
        const { previousSiblings: mpPreviousSiblings, nearestAncestors: mpNearestAncestors } = mergedPages;
        const { siblings: siblings, ancestorSiblings: ancestorSiblings } = $2d6e196d41c25516$var$shiftedSiblings(currentPage, ancestorIndex, 'previousSiblings');
        // previousSiblings
        mpPreviousSiblings.nodes = (0, (/*@__PURE__*/$parcel$interopDefault($4pQus)))(mpPreviousSiblings.nodes, siblings.nodes, 'id');
        (_mpPreviousSiblings_pageInfo = mpPreviousSiblings.pageInfo).hasNextPage && (_mpPreviousSiblings_pageInfo.hasNextPage = siblings.pageInfo.hasNextPage);
        // nearestAncestors
        const ancestors = $2d6e196d41c25516$var$removeSiblingsFromAncestors(currentPage);
        mpNearestAncestors.nodes = (0, (/*@__PURE__*/$parcel$interopDefault($4pQus)))(mpNearestAncestors.nodes, ancestors.nodes, 'id');
        (_mpNearestAncestors_pageInfo = mpNearestAncestors.pageInfo).hasNextPage && (_mpNearestAncestors_pageInfo.hasNextPage = ancestors.pageInfo.hasNextPage);
        // nearestAncestors.previousSiblings
        ancestorSiblings.forEach((ancestorSiblingsAtLevel, i)=>{
            if (i < mpNearestAncestors.nodes.length) {
                var _ancestor_previousSiblings_pageInfo;
                const ancestor = mpNearestAncestors.nodes[i];
                ancestor.previousSiblings.nodes = (0, (/*@__PURE__*/$parcel$interopDefault($4pQus)))(ancestor.previousSiblings.nodes, ancestorSiblingsAtLevel.nodes, 'id');
                (_ancestor_previousSiblings_pageInfo = ancestor.previousSiblings.pageInfo).hasNextPage && (_ancestor_previousSiblings_pageInfo.hasNextPage = ancestorSiblingsAtLevel.pageInfo.hasNextPage);
            }
        });
        return mergedPages;
    });
};
const $2d6e196d41c25516$export$91bc0c39412b216c = (currentPage, rootId, previousCursors, direction)=>{
    if (!currentPage) return previousCursors;
    const previous = direction === 'following' ? previousCursors.previous : $2d6e196d41c25516$var$getPreviousCursor(currentPage, previousCursors.previous);
    const following = direction === 'previous' ? previousCursors.following : $2d6e196d41c25516$var$getFollowingCursor(currentPage, previousCursors.following, rootId);
    return {
        previous: previous,
        following: following
    };
};
const $2d6e196d41c25516$var$getPreviousCursor = (currentPage, lastCursor)=>{
    // if current page has ancestors, get deepest ancestor, else current node
    // if page has previous siblings, then previousmost sibling, otherwise current node
    const ancestorIndex = currentPage.nearestAncestors.nodes.length - 1;
    const adjustedIndex = ancestorIndex + (lastCursor?.ancestorIndex ?? -1) + 1;
    const furthestAncestor = currentPage.nearestAncestors.nodes[ancestorIndex] ?? currentPage;
    const siblingIndex = furthestAncestor.previousSiblings.nodes.length - 1;
    const firstPage = furthestAncestor.previousSiblings.nodes[siblingIndex] ?? furthestAncestor;
    return {
        id: firstPage.id,
        ancestorIndex: adjustedIndex
    };
};
const $2d6e196d41c25516$var$getFollowingCursor = (currentPage, lastCursor, rootId)=>{
    // find deepest ancestor's deepest following sibling
    // if none, then last following sibling
    // if no sibling, then last child
    // if no children, then current page
    //findLastIndex is not supported in testing or SSR as it's not supported in node until 18.0.0 and we're on 16.20.0
    if (!Array.prototype.findLastIndex) Array.prototype.findLastIndex = function(callback, thisArg) {
        for(let i = this.length - 1; i >= 0; i--){
            if (callback.call(thisArg, this[i], i, this)) return i;
        }
        return -1;
    };
    const ancestorIndex = currentPage.nearestAncestors.nodes.findLastIndex((a)=>a.id !== rootId && a.followingSiblings.nodes.length > 0);
    const adjustedIndex = ancestorIndex + (lastCursor?.ancestorIndex ?? -1) + 1;
    if (ancestorIndex >= 0) {
        const siblings = currentPage.nearestAncestors.nodes[ancestorIndex].followingSiblings.nodes;
        const siblingIndex = siblings.length - 1;
        const sibling = siblings[siblingIndex];
        return {
            id: sibling.id,
            ancestorIndex: adjustedIndex
        };
    }
    const siblingIndex = currentPage.followingSiblings.nodes.length - 1;
    if (siblingIndex >= 0 && currentPage.id !== rootId) {
        const sibling = currentPage.followingSiblings.nodes[siblingIndex];
        return {
            id: sibling.id,
            ancestorIndex: adjustedIndex
        };
    }
    const childIndex = currentPage.children.nodes.length - 1;
    if (childIndex >= 0) {
        const child = currentPage.children.nodes[childIndex];
        return {
            id: child.id,
            ancestorIndex: adjustedIndex - 1
        };
    }
    return {
        id: currentPage.id,
        ancestorIndex: adjustedIndex
    };
};
module.exports["getPages"] = $2d6e196d41c25516$export$f4348e32a399a3d5;
module.exports["getIds"] = $2d6e196d41c25516$export$24b60fe7179439bc;
module.exports["getRootId"] = $2d6e196d41c25516$export$dfdcab00b0f585a9;
module.exports["childrenAreLatest"] = $2d6e196d41c25516$export$34b8009d9e031a81;
module.exports["mergePages"] = $2d6e196d41c25516$export$a03c6b8408b76abc;
module.exports["mergeChildren"] = $2d6e196d41c25516$export$f44f2073cd5157ff;
module.exports["isFollowingNodeHidden"] = $2d6e196d41c25516$export$b7edc5fdcf19d0d6;
module.exports["isPageTreeTruncatedPrevious"] = $2d6e196d41c25516$export$617edbc60225ba65;
module.exports["isPageTreeTruncatedFollowing"] = $2d6e196d41c25516$export$d5bc22e72508f579;
module.exports["getAncestryIds"] = $2d6e196d41c25516$export$e96fe946844343ed;
module.exports["mergeFollowingPages"] = $2d6e196d41c25516$export$6fd1afbfe6d62ded;
module.exports["mergePreviousPages"] = $2d6e196d41c25516$export$880f73148296bc22;
module.exports["getDirectionalCursors"] = $2d6e196d41c25516$export$91bc0c39412b216c;

});

parcelRegister("9rjMR", function(module, exports) {
const $6df5fbff1b31b2b4$export$70918a400db2b6af = 'VIRTUAL_ROOT_ID';
const $6df5fbff1b31b2b4$export$3b2fc9888fc801ce = 'VIRTUAL_LOCAL_ROOT_ID';
module.exports["VIRTUAL_ROOT_ID"] = $6df5fbff1b31b2b4$export$70918a400db2b6af;
module.exports["VIRTUAL_LOCAL_ROOT_ID"] = $6df5fbff1b31b2b4$export$3b2fc9888fc801ce;

});

parcelRegister("jGj7w", function(module, exports) {

var $g7NcR = parcelRequire("g7NcR");


var $1wIeS = parcelRequire("1wIeS");


var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");


var $fG32j = parcelRequire("fG32j");


var $7Sm4c = parcelRequire("7Sm4c");


var $95rLf = parcelRequire("95rLf");


var $bFDX4 = parcelRequire("bFDX4");


var $hT3jf = parcelRequire("hT3jf");


var $3SAD5 = parcelRequire("3SAD5");


var $k0x5M = parcelRequire("k0x5M");


var $9rjMR = parcelRequire("9rjMR");


var $2qvBe = parcelRequire("2qvBe");

const $388cba5c68dad66f$export$106b50bd1e988b07 = {
    expandedPages: new Set(),
    loadingPages: new Set(),
    pages: {},
    space: null,
    spaceKey: null,
    rootId: null,
    isTreeTruncatedPrevious: false,
    isTreeTruncatedFollowing: false,
    cursors: {},
    initialPages: {},
    error: null,
    blogPeekRoot: undefined,
    focusedPageId: null,
    isPageTreeLoading: true,
    contentIdsWithLoadedChildren: new Set()
};
let $388cba5c68dad66f$export$841cc07eee4356f9 = $388cba5c68dad66f$export$106b50bd1e988b07;
const $388cba5c68dad66f$export$1c57db10a4d0e1b8 = (spaceKey)=>Object.keys($388cba5c68dad66f$export$841cc07eee4356f9.pages).length > 0 && //there are pages in the package level variable
    $388cba5c68dad66f$export$841cc07eee4356f9.spaceKey === spaceKey; //and the persisted state has the same spacekey as the props
const $388cba5c68dad66f$var$toError = (error)=>error instanceof Error ? error : new Error(String(error));
const $388cba5c68dad66f$var$isApolloErrorInterop = (error)=>'graphQLErrors' in error || 'networkError' in error;
const $388cba5c68dad66f$var$isExpectedPageTreeLoadError = (error)=>$388cba5c68dad66f$var$isApolloErrorInterop(error) && ((0, $fG32j.isSpaceRestrictedError)(error) || (0, $95rLf.isExpectedApolloError)(error) || (0, $bFDX4.isTooManyRequestsError)(error));
const $388cba5c68dad66f$export$e324594224ef24da = {
    initializeState: ()=>({ setState: setState, dispatch: dispatch }, { currentPageId: currentPageId, spaceKey: spaceKey, highlightPages: highlightPages = [], initialData: initialData, isPeekingFromBlogs: isPeekingFromBlogs, syntheticItem: syntheticItem, syntheticItemIsDraft: syntheticItemIsDraft, detached: detached })=>{
            if ($388cba5c68dad66f$export$1c57db10a4d0e1b8(spaceKey) && !detached) setState({
                ...$388cba5c68dad66f$export$841cc07eee4356f9,
                pages: (0, $k0x5M.transformUIAttributes)($388cba5c68dad66f$export$841cc07eee4356f9.pages, currentPageId, $388cba5c68dad66f$export$841cc07eee4356f9.expandedPages, $388cba5c68dad66f$export$841cc07eee4356f9.loadingPages, highlightPages)
            });
            else if (initialData && Object.keys(initialData).length > 0) try {
                const stateFromData = (0, $k0x5M.deriveStateFromData)(initialData, spaceKey, {
                    ...$388cba5c68dad66f$export$106b50bd1e988b07,
                    expandedPages: new Set(),
                    loadingPages: new Set()
                }, isPeekingFromBlogs, syntheticItem, syntheticItemIsDraft);
                dispatch($388cba5c68dad66f$export$e324594224ef24da.setStateWithUIAttributes(stateFromData));
                dispatch($388cba5c68dad66f$export$e324594224ef24da.setIsPageTreeLoading(false));
            } catch (error) {
                dispatch($388cba5c68dad66f$export$e324594224ef24da.handleLoadingError($388cba5c68dad66f$var$toError(error)));
            }
            else setState({
                ...$388cba5c68dad66f$export$106b50bd1e988b07,
                expandedPages: new Set(),
                loadingPages: new Set(),
                spaceKey: spaceKey
            });
        },
    getState: ()=>({ getState: getState })=>{
            return getState();
        },
    //only fires when props change on the container
    derivedStateFromPropsReplacement: ()=>({ dispatch: dispatch, getState: getState }, { currentPageId: currentPageId, highlightPages: highlightPages = [], spaceKey: spaceKey })=>{
            //should really check if any of these props changed
            const { pages: pages, expandedPages: expandedPages, loadingPages: loadingPages } = getState();
            dispatch($388cba5c68dad66f$export$e324594224ef24da.setStateWithUIAttributes({
                pages: (0, $k0x5M.transformUIAttributes)(pages, currentPageId, expandedPages, loadingPages, highlightPages),
                spaceKey: spaceKey
            }));
        },
    updatePersistedState: ()=>({ getState: getState }, { detached: detached })=>{
            if (!detached) {
                //don't save state if we're in the move page dialog
                const state = getState();
                $388cba5c68dad66f$export$841cc07eee4356f9 = state;
            }
        },
    setStateWithUIAttributes: (stateObj)=>({ setState: setState, getState: getState, dispatch: dispatch }, { currentPageId: currentPageId, highlightPages: highlightPages = [] })=>{
            //this is a brute force access to state, it kinda doesn't follow the conventions of sweet state...buuut the alternative is a lot of very samey setters
            setState({
                ...stateObj
            });
            const { pages: pages, expandedPages: expandedPages, loadingPages: loadingPages, cursors: cursors } = getState();
            //this function allows us to transformUIAttributes universally on update
            //toDo: move these properties to state and simply read the sweet state via hooks lower in the tree rather than updating the pages state
            setState({
                //this is
                pages: (0, $k0x5M.transformUIAttributes)(pages, currentPageId, expandedPages, loadingPages, highlightPages, cursors)
            });
            dispatch($388cba5c68dad66f$export$e324594224ef24da.setFocusPageId());
        },
    addLoadingPage: (pageId)=>({ getState: getState, dispatch: dispatch })=>{
            dispatch($388cba5c68dad66f$export$e324594224ef24da.setStateWithUIAttributes({
                loadingPages: getState().loadingPages.add(pageId)
            }));
        },
    setIsPageTreeLoading: (bool)=>({ setState: setState })=>{
            setState({
                isPageTreeLoading: bool
            });
        },
    setIsTreeTruncated: (bool)=>({ setState: setState })=>{
            setState({
                isTreeTruncated: bool
            });
        },
    setIsTreeTruncatedPrevious: (bool)=>({ setState: setState })=>{
            setState({
                isTreeTruncatedPrevious: bool
            });
        },
    setIsTreeTruncatedFollowing: (bool)=>({ setState: setState })=>{
            setState({
                isTreeTruncatedFollowing: bool
            });
        },
    deleteLoadingPage: (pageId)=>({ getState: getState, dispatch: dispatch })=>{
            const { loadingPages: loadingPages } = getState();
            loadingPages.delete(pageId);
            dispatch($388cba5c68dad66f$export$e324594224ef24da.setStateWithUIAttributes({
                loadingPages: loadingPages
            }));
        },
    expandPage: (page, queryChildren, options)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { onExpand: onExpand })=>{
            const { pages: pages, expandedPages: expandedPages, loadingPages: loadingPages, space: space } = getState();
            const expandedPage = pages[page.id];
            const isForceRefresh = options?.forceRefresh ?? false;
            if (expandedPages.has(page.id) && !isForceRefresh || !expandedPage.hasChildren && expandedPage.data.type !== 'folder') return;
            const mergedExpansions = [
                page.id,
                ...(0, $2qvBe.getAncestryIds)(page.id, pages, new Set())
            ];
            if (expandedPage.hasChildren && !(0, $2qvBe.childrenAreLatest)(expandedPage)) {
                if (!queryChildren) return;
                dispatch($388cba5c68dad66f$export$e324594224ef24da.setStateWithUIAttributes({
                    loadingPages: new Set([
                        ...loadingPages,
                        expandedPage.id
                    ])
                }));
                const children = {};
                const { nodes: nodes, error: error } = await queryChildren(expandedPage.id);
                if (error) {
                    //toDo: handle loading children error here, then reset state so they can attempt to re-expand
                    const loadingPagesAfterError = new Set(getState().loadingPages);
                    loadingPagesAfterError.delete(expandedPage.id);
                    dispatch($388cba5c68dad66f$export$e324594224ef24da.setStateWithUIAttributes({
                        loadingPages: loadingPagesAfterError
                    }));
                    return;
                }
                const queriedChildren = (0, $2qvBe.getPages)({
                    nodes: nodes
                });
                queriedChildren.forEach((child)=>{
                    children[child.id] = (0, $k0x5M.createTreeItem)(child);
                });
                // It's possible for the childen to change locally (via DnD) while the queryChildren request is in-flight.
                // Get the latest children now (after the request finished) to prevent a loss of state.
                const { pages: latestPages, loadingPages: latestLoadingPages } = getState();
                const latestChildren = latestPages[expandedPage.id].children;
                latestChildren.forEach((id)=>{
                    children[id] = latestPages[id];
                });
                const childIds = (0, (/*@__PURE__*/$parcel$interopDefault($1wIeS)))([
                    ...(0, $2qvBe.getIds)(queriedChildren),
                    ...latestChildren
                ]);
                let allPages = (0, $2qvBe.mergePages)(latestPages, children);
                allPages = (0, $g7NcR.default)(allPages, (editedAllPages)=>{
                    // @ts-ignore hasAdditionalChildren not available in AK tree. Can remove when using pragmatic types.
                    editedAllPages[expandedPage.id].hasAdditionalChildren = false;
                });
                const nextLoadingPages = new Set(latestLoadingPages);
                nextLoadingPages.delete(expandedPage.id);
                const finalPages = (0, $k0x5M.setChildren)(allPages, expandedPage.id, childIds);
                dispatch($388cba5c68dad66f$export$e324594224ef24da.setStateWithUIAttributes({
                    //use dispatch to make sure that if special properties are changed the tree is re-jiggered
                    loadingPages: nextLoadingPages,
                    pages: finalPages
                }));
                if (onExpand && !isForceRefresh && !options?.suppressAnalytics) onExpand(finalPages[expandedPage.id], {
                    spaceId: space?.id
                });
            }
            const { expandedPages: latestExpandedPages, contentIdsWithLoadedChildren: latestContentIdsWithLoadedChildren } = getState();
            setState({
                contentIdsWithLoadedChildren: new Set([
                    ...latestContentIdsWithLoadedChildren,
                    ...mergedExpansions
                ])
            });
            dispatch($388cba5c68dad66f$export$e324594224ef24da.setStateWithUIAttributes({
                expandedPages: new Set([
                    ...latestExpandedPages,
                    ...mergedExpansions
                ])
            }));
        },
    expandSpaceHomepage: ()=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const { pages: pages, expandedPages: expandedPages, contentIdsWithLoadedChildren: contentIdsWithLoadedChildren, space: space } = getState();
            const homepageId = space?.homepage?.id;
            if (!homepageId) return;
            // the home page might still not be loaded in some weirder cases
            const expandedPage = pages[homepageId];
            if (expandedPages.has(homepageId) || !expandedPage?.hasChildren) return;
            const mergedExpansions = [
                homepageId,
                ...(0, $2qvBe.getAncestryIds)(homepageId, pages, new Set())
            ];
            setState({
                contentIdsWithLoadedChildren: new Set([
                    ...contentIdsWithLoadedChildren,
                    ...mergedExpansions
                ])
            });
            dispatch($388cba5c68dad66f$export$e324594224ef24da.setStateWithUIAttributes({
                expandedPages: new Set([
                    ...expandedPages,
                    ...mergedExpansions
                ])
            }));
        },
    collapsePage: (page)=>({ getState: getState, dispatch: dispatch }, { onCollapse: onCollapse })=>{
            const { expandedPages: expandedPages, space: space } = getState();
            expandedPages.delete(page.id);
            dispatch($388cba5c68dad66f$export$e324594224ef24da.setStateWithUIAttributes({
                expandedPages: expandedPages
            }));
            if (onCollapse) onCollapse(page, {
                spaceId: space?.id
            });
        },
    movePageInState: (pageId, source, destination, queryChildren, expandAfter)=>({ getState: getState, dispatch: dispatch })=>{
            const { rootId: rootId, pages: pages, expandedPages: expandedPages } = getState();
            let newTree = {
                rootId: rootId,
                items: pages
            };
            const destinationParent = newTree.items[destination.parentId];
            if (source.index === undefined) {
                newTree = (0, $3SAD5.removeChild)(newTree, source.parentId, pageId);
                newTree = (0, $3SAD5.addChild)(newTree, destination.parentId, pageId, destination.index);
            } else newTree = (0, $3SAD5.moveItemOnTree)(newTree, source, destination);
            if (newTree.items[source.parentId].children.length === 0) expandedPages.delete(source.parentId);
            dispatch($388cba5c68dad66f$export$e324594224ef24da.setStateWithUIAttributes({
                pages: newTree.items,
                rootId: newTree.rootId,
                expandedPages: expandedPages
            }));
            if (expandAfter) dispatch($388cba5c68dad66f$export$e324594224ef24da.expandPage(destinationParent, queryChildren));
        },
    handleLoadingError: (error, location)=>({ setState: setState }, { onLoadError: onLoadError })=>{
            if (!error) return;
            const errorState = {
                error: error,
                location: location
            };
            if ($388cba5c68dad66f$var$isExpectedPageTreeLoadError(error)) {
                // Until we have a proper "restricted" state, we will show the
                // error state in case of restricted error, but mark the error
                // as expected so the experience will still succeed
                (0, $7Sm4c.markErrorAsHandled)(error);
                errorState.isExpected = true;
            }
            //todo: to handle loading children and previous next errors without causing the whole tree to crash we may want to wrap this in if(location)
            //however that means the error will not be reported and we need a programatic way of ding that. OR new places to render the error handler at the top / bottom/ as a child of tree elements
            setState({
                error: errorState
            });
            if (onLoadError) onLoadError(error, {
                isExpected: errorState.isExpected,
                errorLocation: errorState.location
            });
        },
    clearError: ()=>({ setState: setState })=>{
            setState({
                error: null
            });
        },
    updateSinglePage: (id, data)=>({ getState: getState, dispatch: dispatch })=>{
            const { pages: pages } = getState();
            // Do nothing if we aren't tracking this page state in the pagetree
            if (!pages[id]) return;
            const pageToUpdate = {
                ...pages[id],
                data: {
                    ...pages[id].data,
                    ...data
                }
            };
            dispatch($388cba5c68dad66f$export$e324594224ef24da.setStateWithUIAttributes({
                pages: {
                    ...pages,
                    [id]: pageToUpdate
                }
            }));
        },
    /**
   * Invalidate the cached children of a folder so the next access pulls a
   * fresh page from the network, and — if the folder is currently expanded —
   * immediately re-runs the children query so the tree shows the new state
   * without requiring the user to collapse + re-expand.
   *
   * Used after smart-folder sync/unsync so the synced children appear in the
   * tree without a full page refresh.
   */ refreshChildren: (id, queryChildren)=>({ getState: getState, dispatch: dispatch })=>{
            const { pages: pages, expandedPages: expandedPages, loadingPages: loadingPages } = getState();
            const page = pages[id];
            if (!page || page.data.type !== 'folder') return;
            // Mark children as stale so `childrenAreLatest` returns false and any
            // future expandPage call will refetch.
            const invalidatedPages = (0, $g7NcR.default)(pages, (draft)=>{
                draft[id].hasChildren = true;
                draft[id].hasAdditionalChildren = true;
            });
            if (!expandedPages.has(id) || loadingPages.has(id)) {
                dispatch($388cba5c68dad66f$export$e324594224ef24da.setStateWithUIAttributes({
                    pages: invalidatedPages
                }));
                return;
            }
            // Folder is currently expanded — keep it open while the refresh runs to
            // avoid a collapse/re-expand flash, but bypass expandPage's usual
            // already-expanded early return so fresh children are fetched.
            dispatch($388cba5c68dad66f$export$e324594224ef24da.setStateWithUIAttributes({
                pages: invalidatedPages
            }));
            dispatch($388cba5c68dad66f$export$e324594224ef24da.expandPage(invalidatedPages[id], queryChildren, {
                forceRefresh: true
            }));
        },
    setFocusPageId: ()=>({ getState: getState, setState: setState }, { currentPageId: currentPageId, highlightPages: highlightPages = [] })=>{
            const { blogPeekRoot: blogPeekRoot } = getState();
            const focusedPageId = blogPeekRoot || currentPageId || highlightPages[0];
            setState({
                focusedPageId: focusedPageId
            });
        },
    getCurrentTreeSize: ()=>({ getState: getState })=>{
            const { pages: pages } = getState();
            return Object.keys(pages).length;
        },
    optimisticInsertContent: ({ contentId: contentId, spaceKey: spaceKey, parentId: parentId, type: type, subType: subType })=>({ getState: getState, setState: setState })=>{
            const { pages: pages, rootId: rootId, spaceKey: currentSpaceKey } = getState();
            const effectiveParentId = parentId || rootId;
            if (pages[contentId]) return; // Page already exists
            if (spaceKey !== currentSpaceKey) return; // Content was created in a different space
            if (!pages[effectiveParentId]?.isExpanded) return; // At this time we only support optimistic insertions for expanded pages
            if (type !== 'page' || subType) return; // At this time we only support optimistic insertions for regular pages
            const newPage = (0, $k0x5M.createTreeItem)({
                id: contentId,
                parentId: effectiveParentId,
                type: type,
                title: '',
                status: 'DRAFT',
                ancestors: [],
                children: [],
                hasChildren: false,
                isSelected: true,
                createdDate: {
                    value: new Date().getTime()
                },
                isOptimistic: true
            });
            const parentPage = {
                ...pages[effectiveParentId],
                children: [
                    ...pages[effectiveParentId].children,
                    contentId
                ],
                hasChildren: true
            };
            const newPages = {
                ...pages,
                [effectiveParentId]: parentPage,
                [contentId]: newPage
            };
            setState({
                pages: newPages
            });
        },
    optimisticInsertSmartLinkEmbed: ({ contentId: contentId, parentId: parentId, title: title, url: url, iconUrl: iconUrl, queryChildren: queryChildren, position: position, movePage: movePage })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const { pages: pages, rootId: rootId } = getState();
            const effectiveParentId = parentId || rootId;
            if (pages[contentId]) return; // Content already exists in the tree
            if (!effectiveParentId || !pages[effectiveParentId]) return; // Parent doesn't exist in the tree
            const { spaceKey: spaceKey } = getState();
            const newItem = (0, $k0x5M.createTreeItem)({
                id: contentId,
                parentId: effectiveParentId,
                type: 'embed',
                title: title || url,
                status: 'CURRENT',
                links: {
                    webui: `/spaces/${spaceKey}/embed/${contentId}`
                },
                ancestors: [],
                children: [],
                hasChildren: false,
                isSelected: false,
                createdDate: {
                    value: new Date().getTime()
                },
                isOptimistic: true
            });
            // Set the icon URL as the emoji field directly on the tree item data.
            // createTreeItem extracts emoji from page.metadata.properties, which we don't have
            // for optimistic inserts. For embeds, the emoji field stores the favicon URL.
            if (iconUrl) newItem.data.emoji = iconUrl;
            const newPages = {
                ...pages,
                [effectiveParentId]: {
                    ...pages[effectiveParentId],
                    children: [
                        ...pages[effectiveParentId].children,
                        contentId
                    ],
                    hasChildren: true
                },
                [contentId]: newItem
            };
            setState({
                pages: newPages
            });
            // Expand the parent so the newly inserted item is visible
            const parentPage = newPages[effectiveParentId];
            if (!parentPage.isExpanded) dispatch($388cba5c68dad66f$export$e324594224ef24da.expandPage(parentPage, queryChildren));
            // Reposition to the exact drop location if a sibling position was specified
            if (position && movePage) {
                const { siblingId: siblingId, placement: placement } = position;
                const targetOffset = placement === 'before' ? 0 : 1;
                const { pages: currentPages } = getState();
                const parentChildren = currentPages[effectiveParentId]?.children || [];
                const siblingIndex = parentChildren.indexOf(siblingId);
                if (siblingIndex >= 0) dispatch($388cba5c68dad66f$export$e324594224ef24da.movePageInState(contentId, {
                    parentId: effectiveParentId,
                    index: parentChildren.length - 1
                }, {
                    parentId: effectiveParentId,
                    index: siblingIndex + targetOffset
                }, undefined));
                await movePage({
                    pageId: contentId,
                    siblingId: siblingId,
                    positionToSibling: placement
                });
            }
        },
    optimisticDeleteContent: (contentId, deleteCallback)=>({ getState: getState, setState: setState })=>{
            const { pages: pages, rootId: rootId } = getState();
            const targetPage = pages?.[contentId];
            const parentId = targetPage?.parentId || rootId;
            if (!targetPage || !parentId || !pages[parentId]?.children) {
                if (deleteCallback) deleteCallback();
                return; // Page doesn't exist, parent doesn't exist, or parent has no children
            }
            const parentPage = {
                ...pages[parentId],
                children: pages[parentId].children.filter((childId)=>childId !== contentId),
                hasChildren: pages[parentId].children.length > 1
            };
            //copy pages minus the targetPage
            const { [contentId]: _deletedKey, ...otherPages } = pages;
            const newPages = {
                ...otherPages,
                [parentId]: parentPage
            };
            setState({
                pages: newPages
            });
            if (deleteCallback) deleteCallback();
        }
};
const $388cba5c68dad66f$var$Store = (0, $8s9DV.createStore)({
    // @ts-ignore
    initialState: {
        ...$388cba5c68dad66f$export$106b50bd1e988b07,
        expandedPages: new Set(),
        loadingPages: new Set()
    },
    actions: $388cba5c68dad66f$export$e324594224ef24da,
    name: 'pageTreeState'
});
const $388cba5c68dad66f$export$f4ecd42d78b0271b = (0, $j8on0.createContainer)($388cba5c68dad66f$var$Store, {
    onInit: $388cba5c68dad66f$export$e324594224ef24da.initializeState,
    // @ts-ignore
    onUpdate: $388cba5c68dad66f$export$e324594224ef24da.derivedStateFromPropsReplacement
});
const $388cba5c68dad66f$export$7e29a7688fb5a693 = (0, $kBr4q.createHook)($388cba5c68dad66f$var$Store);
const $388cba5c68dad66f$export$187b5f4b52e93ae2 = (0, $kBr4q.createActionsHook)($388cba5c68dad66f$var$Store);
const $388cba5c68dad66f$export$abe36402cc730165 = (0, $kBr4q.createHook)($388cba5c68dad66f$var$Store, {
    selector: (state)=>state.contentIdsWithLoadedChildren
});
const $388cba5c68dad66f$export$3bc5313e88d1eb58 = (0, $kBr4q.createHook)($388cba5c68dad66f$var$Store, {
    selector: (state, itemId)=>{
        const parentId = state.pages[itemId]?.parentId;
        if (!parentId) return false;
        return (0, $hT3jf.isSmartFolder)(state.pages[parentId]?.data ?? {});
    }
});
const $388cba5c68dad66f$export$585b0f549ebb5244 = (pages, itemId)=>{
    const declaredParentId = pages[itemId]?.parentId;
    if (declaredParentId && pages[declaredParentId]?.children?.includes(itemId)) return declaredParentId;
    return Object.keys(pages).find((id)=>pages[id]?.children?.includes(itemId));
};
const $388cba5c68dad66f$var$NO_MOVE_ACTIONS = {
    canMoveUp: false,
    canMoveDown: false,
    canMoveOut: false,
    canMoveInto: false,
    canMoveToTop: false,
    canMoveToBottom: false
};
const $388cba5c68dad66f$export$d5f53b181cd01e5 = (pages, itemId)=>{
    const item = pages[itemId];
    const parentId = item ? $388cba5c68dad66f$export$585b0f549ebb5244(pages, itemId) : undefined;
    const parent = parentId ? pages[parentId] : undefined;
    const siblings = parent?.children ?? [];
    const index = siblings.indexOf(itemId);
    if (!item || !parentId || !parent || index === -1) return $388cba5c68dad66f$var$NO_MOVE_ACTIONS;
    if ((0, $k0x5M.isManagedFolder)(parent.data)) return $388cba5c68dad66f$var$NO_MOVE_ACTIONS;
    const grandparentId = $388cba5c68dad66f$export$585b0f549ebb5244(pages, parentId);
    const canMoveOut = !!grandparentId && grandparentId !== (0, $9rjMR.VIRTUAL_ROOT_ID) && grandparentId !== (0, $9rjMR.VIRTUAL_LOCAL_ROOT_ID) && !!pages[grandparentId];
    let canMoveInto = false;
    if (index > 0) {
        const previousSibling = pages[siblings[index - 1]];
        canMoveInto = !!previousSibling && !(0, $k0x5M.isManagedFolder)(previousSibling.data) && previousSibling.data.status === 'CURRENT';
    }
    return {
        canMoveUp: index > 0,
        canMoveDown: index < siblings.length - 1,
        canMoveOut: canMoveOut,
        canMoveInto: canMoveInto,
        canMoveToTop: index > 0,
        canMoveToBottom: index < siblings.length - 1
    };
};
const $388cba5c68dad66f$export$5d23ead238c24e53 = (0, $kBr4q.createHook)($388cba5c68dad66f$var$Store, {
    selector: (state, itemId)=>$388cba5c68dad66f$export$d5f53b181cd01e5(state.pages, itemId)
});
module.exports["PageTreeStateContainer"] = $388cba5c68dad66f$export$f4ecd42d78b0271b;
module.exports["usePageTreeState"] = $388cba5c68dad66f$export$7e29a7688fb5a693;
module.exports["usePageTreeActions"] = $388cba5c68dad66f$export$187b5f4b52e93ae2;
module.exports["useContentIdsWithLoadedChildren"] = $388cba5c68dad66f$export$abe36402cc730165;
module.exports["useHasManagedParent"] = $388cba5c68dad66f$export$3bc5313e88d1eb58;
module.exports["findParentId"] = $388cba5c68dad66f$export$585b0f549ebb5244;
module.exports["useMoveActionsCapability"] = $388cba5c68dad66f$export$5d23ead238c24e53;

});

parcelRegister("3SAD5", function(module, exports) {
const $6311439f964a7bc2$export$59da04d16460addd = (tree, parentId, itemId, index)=>{
    const parent = tree.items[parentId];
    const newChildren = [
        ...parent.children
    ];
    newChildren.splice(index, 0, itemId);
    return $6311439f964a7bc2$var$mutateTree(tree, parentId, {
        children: newChildren,
        hasChildren: true
    });
};
const $6311439f964a7bc2$export$7ae609f7af59e4f7 = (tree, parentId, itemId)=>{
    const parent = tree.items[parentId];
    const newChildren = parent.children.filter((id)=>id !== itemId);
    const hasChildren = newChildren.length > 0 || Boolean(parent.hasAdditionalChildren);
    if (newChildren.length !== parent.children.length) return $6311439f964a7bc2$var$mutateTree(tree, parentId, {
        children: newChildren,
        hasChildren: hasChildren,
        isExpanded: hasChildren && parent.isExpanded
    });
    return tree;
};
const $6311439f964a7bc2$export$151553fb522a6220 = (tree, itemId, data)=>{
    return $6311439f964a7bc2$var$mutateTree(tree, itemId, {
        data: {
            ...tree.items[itemId].data,
            ...data
        }
    });
};
function $6311439f964a7bc2$export$7714407ea87aca85(tree, source, destination) {
    const { items: items } = tree;
    const newItems = {
        ...items
    };
    // remove item from old location
    const sourceChildren = [
        ...newItems[source.parentId].children
    ];
    sourceChildren.splice(source.index, 1);
    newItems[source.parentId] = {
        ...newItems[source.parentId],
        children: sourceChildren,
        hasChildren: Boolean(sourceChildren.length)
    };
    // put item in its new location
    const destinationParent = newItems[destination.parentId];
    const destinationChildren = [
        ...destinationParent.children
    ];
    const itemId = items[source.parentId].children[source.index];
    if (typeof destination.index === 'undefined') /**
     * When the destination index is undefined, we "combine" the items by appending the item to the end of destination.
     * We ONLY do this if the destination has already loaded children OR is a leaf node.
     * If the destination is an unexpanded item with children, the moved item will appear when the user expands.
     */ destinationChildren.push(itemId);
    else destinationChildren.splice(destination.index, 0, itemId);
    newItems[destination.parentId] = {
        ...newItems[destination.parentId],
        children: destinationChildren,
        hasChildren: true,
        // This data is needed to determine whether children have been loaded already.
        // A page might have children that were added via DnD, but have "additional" children yet to be fetched from the server.
        hasAdditionalChildren: destinationParent.hasAdditionalChildren || destinationParent.hasChildren && destinationParent.children.length === 0
    };
    return {
        ...tree,
        items: newItems
    };
}
const $6311439f964a7bc2$var$mutateTree = (tree, itemId, mutation)=>{
    const itemToChange = tree.items[itemId];
    if (!itemToChange) // Item not found
    return tree;
    // Returning a clone of the tree structure and overwriting the field coming in mutation
    return {
        // rootId should not change
        rootId: tree.rootId,
        items: {
            // copy all old items
            ...tree.items,
            // overwriting only the item being changed
            [itemId]: {
                ...itemToChange,
                ...mutation
            }
        }
    };
};
module.exports["addChild"] = $6311439f964a7bc2$export$59da04d16460addd;
module.exports["removeChild"] = $6311439f964a7bc2$export$7ae609f7af59e4f7;
module.exports["moveItemOnTree"] = $6311439f964a7bc2$export$7714407ea87aca85;

});

parcelRegister("hySOz", function(module, exports) {
$parcel$export(module.exports, "PageTreeQuickActions", () => (parcelRequire("chIAd")).PageTreeQuickActions);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");


var $chIAd = parcelRequire("chIAd");



const $4938a4ac4072e24f$export$fd6f8aa63961aeed = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "0zuTW",
    name: "InlineRename",
    loader: async ()=>(await (parcelRequire("lDXQb"))).InlineRename,
    loading: ({ children: children })=>children
});
module.exports["InlineRename"] = $4938a4ac4072e24f$export$fd6f8aa63961aeed;

});

parcelRegister("4TjIQ", function(module, exports) {

let $38fb98f07310b6e0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $38fb98f07310b6e0$var$load("dPFEi"),
    $38fb98f07310b6e0$var$load("6wr18"),
    $38fb98f07310b6e0$var$load("bDfgb"),
    $38fb98f07310b6e0$var$load("4fYzp"),
    $38fb98f07310b6e0$var$load("ffEVr"),
    $38fb98f07310b6e0$var$load("clpSH")
]).then(()=>parcelRequire('cAbTs'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("lDXQb", function(module, exports) {

let $fc1ba8955cd60b00$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fc1ba8955cd60b00$var$load("dPFEi"),
    $fc1ba8955cd60b00$var$load("90vep"),
    $fc1ba8955cd60b00$var$load("bwLq7"),
    $fc1ba8955cd60b00$var$load("fH3TJ"),
    $fc1ba8955cd60b00$var$load("6wr18"),
    $fc1ba8955cd60b00$var$load("dlm6q"),
    $fc1ba8955cd60b00$var$load("5Mm1x"),
    $fc1ba8955cd60b00$var$load("Wowvf"),
    $fc1ba8955cd60b00$var$load("hhss7"),
    $fc1ba8955cd60b00$var$load("ffEVr"),
    $fc1ba8955cd60b00$var$load("7EorR"),
    $fc1ba8955cd60b00$var$load("PNyg1")
]).then(()=>parcelRequire('7K7RC'));

});

parcelRegister("chIAd", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d7143873a399fda1$export$5dca550a712dab6d = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "pWwBV",
    name: "PageTreeQuickActions",
    loader: async ()=>(await (parcelRequire("4TjIQ"))).PageTreeQuickActions
});
$d7143873a399fda1$export$5dca550a712dab6d.displayName = 'lazy(PageTreeQuickActions)';
module.exports["PageTreeQuickActions"] = $d7143873a399fda1$export$5dca550a712dab6d;

});


//# sourceMappingURL=esm.49c1a4ee.js.map
